import { ref } from 'vue';

import {
  CERT_ANNOUNCEMENT_END_DATE,
  CERT_ANNOUNCEMENT_STORAGE_KEY,
} from './constants';

const isVisible = ref(false);

const isAnnouncementPeriod = (): boolean =>
  new Date() < CERT_ANNOUNCEMENT_END_DATE;

const tryShow = () => {
  if (!isAnnouncementPeriod()) return;
  if (sessionStorage.getItem(CERT_ANNOUNCEMENT_STORAGE_KEY)) return;
  isVisible.value = true;
};

const dismiss = () => {
  isVisible.value = false;
  sessionStorage.setItem(CERT_ANNOUNCEMENT_STORAGE_KEY, 'true');
};

const clearDismiss = () => {
  sessionStorage.removeItem(CERT_ANNOUNCEMENT_STORAGE_KEY);
};

export const useSystemAnnouncement = () => ({
  isVisible,
  tryShow,
  dismiss,
  clearDismiss,
});
